import { render, staticRenderFns } from "./IconBlock.vue?vue&type=template&id=38ed5ba4&"
import script from "./IconBlock.vue?vue&type=script&lang=js&"
export * from "./IconBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IconBlock.vue"
export default component.exports